import { palette } from '@app/src/theme/palette'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface AiScreeningStatsProps {
  allowedProviderScreenings: number
  totalProviderScreened: number
  remainingProviderScreenings: number
}

const AiScreeningStats: React.FC<AiScreeningStatsProps> = ({
  allowedProviderScreenings,
  totalProviderScreened,
  remainingProviderScreenings,
}) => {
  const { formatMessage } = useIntl()

  return (
    <Stack justifyContent="space-between">
      <Stack bgcolor={palette.communication.light} direction="row" justifyContent="space-between" p={2}>
        <Stack>
          <Typography>{formatMessage({ id: 'dashboard.sourcing.remainingProviderScreenings.limit' })}</Typography>
        </Stack>
        <Typography>{allowedProviderScreenings}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center" flexGrow={1} p={2}>
        <Stack>
          <Typography>{formatMessage({ id: 'dashboard.sourcing.remainingProviderScreenings.completed' })}</Typography>
        </Stack>
        <Typography>-{totalProviderScreened}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center" flexGrow={1} p={2}>
        <Stack>
          <Typography>{formatMessage({ id: 'dashboard.sourcing.remainingProviderScreenings.available' })}</Typography>
        </Stack>
        <Typography>{remainingProviderScreenings}</Typography>
      </Stack>
    </Stack>
  )
}

export default AiScreeningStats
